
export const COUNTRIES = [
  "United States",
  "United Kingdom",
  "Canada",
  "Australia",
  "Germany",
  "France",
  "Spain",
  "Italy",
  "Japan",
  "Brazil",
  "India",
  "China",
  "Singapore",
  "Netherlands",
  "Sweden",
  "Mexico",
  "South Africa",
  "South Korea",
  "Russia",
  "United Arab Emirates",
  "New Zealand",
  "Ireland",
  "Switzerland",
  "Norway",
  "Denmark",
  "Finland",
  "Belgium",
  "Austria",
  "Portugal",
  "Greece"
];
